// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sOHJ","content":"styles_content__2DTEf"};